import { isVimeo } from './vimeo';

export interface VideoSrc {
  srcID: string;
  srcType: 'vimeo' | 'youtube';
  url: string;
}

const YOUTUBE_PREFIX = 'https://www.youtube.com/embed/';
const YOUTUBEMATCH_URL =
  /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

export const isYoutube = (url: string): boolean => YOUTUBEMATCH_URL.test(url);

export const getYoutubeSrc = (url: string): VideoSrc | undefined => {
  try {
    const matches = url && url.match(YOUTUBEMATCH_URL);
    const id = matches && matches[1];
    if (id) {
      return {
        srcID: id,
        srcType: 'youtube',
        url,
      };
    }
    return undefined;
  } catch {
    return undefined;
  }
};

export const getYoutubeSrcUrl = (src: string): string | undefined => {
  const videoSrc = getYoutubeSrc(src);
  return videoSrc ? `${YOUTUBE_PREFIX}${videoSrc.srcID}` : undefined;
};

export const isVideoLink = (url: string | undefined): boolean => {
  if (!url) return false;
  return isYoutube(url) || isVimeo(url);
};
